import { StorageKeys, StorageTypes } from '../constants';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StorageService {
  public get<T = unknown>(key: string, storageType: StorageTypes = StorageTypes.LocalStorage): T {
    let value = '';
    if (storageType === StorageTypes.LocalStorage) {
      value = localStorage.getItem(key) ?? '';
    } else {
      value = sessionStorage.getItem(key) ?? '';
    }

    try {
      return JSON.parse(value) as T;
    } catch {
      return value as T;
    }
  }

  public set(key: string, value: unknown, storageType: StorageTypes = StorageTypes.LocalStorage) {
    if (!value) {
      if (storageType === StorageTypes.LocalStorage) {
        localStorage.removeItem(key);
      } else {
        sessionStorage.removeItem(key);
      }
      return;
    }
    if (storageType === StorageTypes.LocalStorage) {
      localStorage.setItem(key, JSON.stringify(value) ?? String(value));
    } else {
      sessionStorage.setItem(key, JSON.stringify(value) ?? String(value));
    }
  }

  public get TrainingCenterGeminiId() {
    return this.get<number>(StorageKeys.TrainingCenterGeminiId);
  }

  public set TrainingCenterGeminiId(id: number) {
    this.set(StorageKeys.TrainingCenterGeminiId, id);
  }

  public get DRK() {
    return this.get<string>(StorageKeys.DRK);
  }

  public set DRK(token: string) {
    this.set(StorageKeys.DRK, token);
  }

  public get DocumentScannerIpAddress() {
    return this.get<string>(StorageKeys.DocumentScannerIpAddress);
  }

  public set DocumentScannerIpAddress(ipAddress: string) {
    this.set(StorageKeys.DocumentScannerIpAddress, ipAddress);
  }

  public get byPassCode() {
    return this.get<string>(StorageKeys.ByPassCode);
  }

  public set byPassCode(byPassCode: string) {
    this.set(StorageKeys.ByPassCode, byPassCode);
  }
}
